import { getImage, IArtDirectedImage, IGatsbyImageData } from 'gatsby-plugin-image';

import { ImagesContent } from '../../../@types/content/images';

export const getArtDirectedArticlePreviewFeaturedImages = (
  breakpoints: ImagesContent.ArticlePreviewFeaturedImageBreakpoint[],
  imageData: ImagesContent.ArticlePreviewFeaturedImage
): IArtDirectedImage[] =>
  breakpoints
    .filter(({ alias }) => !!getImage(imageData[alias]))
    .map(({ alias, media }) => ({
      media,
      image: getImage(imageData[alias]) as IGatsbyImageData,
    }));
